"use strict";

import G_marketConfigStorage from 'components/globalMarketConfigStorage';
import { defineSimpleTerm, _I_ } from 'components/locs';
import MoneyUtil from 'components/moneyUtil';
import { BootButton } from 'generics/buttons';
import { IconFontAwesome, IconGlyphicon } from 'generics/icons';
import React from 'react';




export default class ViewItemSellEditor extends React.Component {
  constructor(props)  {
    super(props);

    const sellPriceMin = G_marketConfigStorage.getPriceMin();
    const sellPriceMax = G_marketConfigStorage.getPriceMax();

    const userCurrStr = MoneyUtil.formatCurr(  SettingsInjections.getUsedCurrency().market  );
    const initialPrice = MoneyUtil.parseMoney( this.props.initialPrice );
    const price = Math.max( sellPriceMin,  initialPrice || 10000 );

    const priceText = MoneyUtil.formatMoney(price);
    this.currentLocale = SettingsInjections.getUsedLocale();

    this.state = {
      "agree" : false,
      sellPriceMin,
      sellPriceMax,
      price,
      priceText,
      amountText: "",
      sellAmount: 1,
      totalAmount: 0,
      instances: [],
      userCurrStr
    }

    this.onAgreeClick = () => {  this.setState({  "agree" : ( this.state.agree ? false : Date.now() )  });  };
    this.onPriceChange = (event)  =>  {  event.preventDefault();  this.processPriceChange(event.target.value);  };
    this.onPriceWheel = (event) => this.handlePriceWheel(event);
    this.onBlurPrice = (event) => this.handleBlurPrice(event);
  }


  handleBlurPrice( e ) {
    const priceText =  MoneyUtil.formatMoney( this.state.price );

    if (priceText != this.state.priceText)  {
      this.setState({ priceText });
    }
  }

  handleAmountBlur = ( e )  =>  {
    const amountText =  `${this.state.sellAmount}`
    if (amountText == this.state.amountText)  {
      return;
    }

    this.setState({ amountText });
  }


  handleAmountWheel = ( e )  =>  {
    e.preventDefault();

    const delta = Math.sign( e.deltaY )*(e.ctrlKey? 10 : 1);
    const newValue = this.state.sellAmount - delta;

    this.processAmountChange((newValue > 0) ? newValue : 0);
  }

  handleAmountChange = ( event )  =>  {
    this.processAmountChange(event.target.value);
  }

  handleFieldSelect = (e) => {
    e.target.select();
  };

  handlePriceWheel( e ) {
    e.preventDefault();

    const delta = 10000*Math.sign( e.deltaY )*(e.ctrlKey? 10 : (e.shiftKey ? 0.1 : 1));
    const newValue = MoneyUtil.formatMoney( this.state.price - delta );

    if ( +newValue >= 0 )  {
      this.processPriceChange( newValue );
    }
  }

  processAmountChange( val )  {
    let [ , amountText ] = (/^\s*([0-9]+)\s*$/).exec( val )||[];
    if ( !amountText )  {
      this.setState({ amountText: "" });
    }

    if (amountText == this.state.amountText)  {
      return;
    }

    let sellAmount = +amountText;
    if (sellAmount > 0)
      this.setState({ sellAmount, amountText });

  }


  processPriceChange( val )  {
    const [ , hi, dot, lo ] = ((/^\s*(\d*)(?:(\.)(\d*))?\s*$/).exec( val ) || []);
    if ( (!hi) && (!lo) )
      return;

    const priceText = `${hi||""}${dot&&"."||""}${lo||""}`;
    if ( this.state.priceText === priceText  )
      return;

    const price = MoneyUtil.parseMoney(priceText);
    if ( isFinite(price) && price >= 0 )
      this.setState({ price, priceText, agree: false });
  }


  getFeeRatio()  {
    const EXCHANGE_FEE = G_marketConfigStorage.getMarketFee();
    const marketFee = this.props.marketFee || 0;
    return ( 1 - EXCHANGE_FEE - marketFee )
  }

  getOrdersPrice(orders) {

    let ordersPrice = 0;

    if(orders.length) {
      orders.forEach((order) => {
        ordersPrice = ordersPrice + parseFloat(order.localPrice);
      });
    }
    return ordersPrice;
  }

  getResult()  {
    const {  sellAmount, sellPriceMin, sellPriceMax, userCurrStr, agree, amountText  } = this.state;
    const {  market  } = SettingsInjections.getUsedCurrency();
    const { isWealthyUser }  =  SettingsInjections.getCredentials();
    const notes = [];

    let isValid = true;
    let amount = Math.floor( sellAmount );

    if ( isFinite( amount ) )  {
      if ( amount < 1 || !amountText )  {
        isValid = false;
        amount = NaN;
        notes.push(_I_("ItemBuyEditor.note.posAmount"));
      }  else if ( amount > 1000 )  {
        isValid = false;
        amount = NaN;
        notes.push(_I_("ItemBuyEditor.note.maxAmount"));
      }
    } else {
      isValid = false;
      amount = NaN;
      notes.push(_I_("ItemBuyEditor.note.invalidAmount"));
    }

    let price = Math.floor( this.state.price );
    let wished = Math.ceil( price * this.getFeeRatio() );
        wished = Math.floor(wished / 100) * 100; // rounding to cents

    let total = (amount * price);
    let totalWished = (amount * wished);

    if ( isFinite(  price ) )  {
      if ( price < sellPriceMin )  {
        isValid = false;
        price = NaN;
        notes.push(`${_I_("ItemSellEditor.note.minPrice")} ${MoneyUtil.formatMoney(sellPriceMin)} ${userCurrStr}`);
      }  else  {
        if ( total > sellPriceMax )  {
          isValid = false;
          price = NaN;
          notes.push(`${_I_("ItemSellEditor.note.maxTotals")} ${MoneyUtil.formatMoney(sellPriceMax)} ${userCurrStr}` );
        }

        const {  sellOrders, sellOrdersTotal, buyOrdersTotal  }  =  this.props.orders;
        const ordersTotal = (+sellOrdersTotal||0) + (+buyOrdersTotal||0);
        const sellOrdersPrice = this.getOrdersPrice(sellOrders);
        const marketBalance = (this.props.balance[market]||0);
        const {  soft_limit,  hard_limit,  op_limit  } = this.props.wlimits;

        if  ( op_limit && totalWished > (op_limit*10000) ) {
          isValid = false;
          price = NaN;
          notes.push(`${_I_("ItemSellEditor.note.maxPrice")} ${ MoneyUtil.formatMoney(op_limit*10000, market) }`);
        }

        const lim = Math.min( soft_limit||Infinity, hard_limit||Infinity );

        if  ( (!isWealthyUser && lim && isFinite(lim) && (marketBalance+totalWished+sellOrdersPrice) > (lim*10000))) {
          isValid = false;
          price = NaN;
          notes.push(`${_I_("ItemSellEditor.note.maxBalance")} ${ MoneyUtil.formatMoney(lim*10000, market) }`);
        }
      }
    }  else  {
      isValid = false;
      price = NaN;
      notes.push(_I_("ItemBuyEditor.note.invalidPrice"));
    }

    if (notes.length != 0)
      isValid = false;

    if ( !isValid )  {
      totalWished = NaN;
    }

    return { isValid, amount: sellAmount, price, wished, totalWished, agree, notes };
  }


  render() {
    const { isValid, price, wished, totalWished, notes }  =  this.getResult();
    const disabled = !(this.state.agree && isValid);
    const { priceText, amountText} = this.state;
    const submitNotes = [
        ...notes,
        ( !this.state.agree &&  _I_("ItemSellEditor.note.mustAgree"))
      ].filter(Boolean).join("\n");

    const {  market  } = SettingsInjections.getUsedCurrency();
    const {  sellOrdersTotal,  buyOrdersTotal  }  =  this.props.orders;

    let marketBalance = (this.props.balance[market]||0);
        // round balances down to nearest cent
        marketBalance = Math.floor((+marketBalance||0)/100)*100;
    let termsUrl = "https://gaijin.net/"+this.currentLocale.icon+"/termsofservice";

    return (
        <div className="view-trade-editor">

              <div className="editor-row">
                <span className="label-column">
                  {_I_("ItemSellEditor.currentBalance.before")} {MoneyUtil.formatMoney(marketBalance,market)} {_I_("ItemSellEditor.currentBalance.after")}
                </span>
              </div>

              {(sellOrdersTotal>0) &&
                <div className="editor-row">
                  <span className="label-column">
                    {_I_("ItemSellEditor.sellOrdersTotal.before")} {MoneyUtil.formatMoney(totalWished,market)} {_I_("ItemSellEditor.sellOrdersTotal.after")}
                  </span>
                </div>}

              {(buyOrdersTotal>0) &&
                <div className="editor-row">
                  <span className="label-column">
                    {_I_("ItemSellEditor.buyOrdersTotal.before")} {MoneyUtil.formatMoney(buyOrdersTotal, market)} {_I_("ItemSellEditor.buyOrdersTotal.after")}
                  </span>
                </div>}
                <br />

            <div className="editor-row">
              <span className="label-column">{_I_("ItemSellEditor.label.price")}</span>
              <span className="input-column" onWheel={ this.onPriceWheel }
                  title={_I_("ItemSellEditor.label.wheelInput")}  >
                <input  className="form-control input-sm"  type="text"
                        value={priceText}
                        onFocus={this.handleFieldSelect}
                        onBlur={this.onBlurPrice}
                        onChange={this.onPriceChange}  />
              </span>
            </div>

          <div className="editor-row">
            <span className="label-column">{_I_("ItemSellEditor.label.amount")}</span>
            <span className="input-column" onWheel={this.handleAmountWheel}
                  title={_I_("ItemBuyEditor.label.wheelAmountInput")}  >
              <input type="text" className="form-control input-sm"
                     value={amountText}
                     onFocus={this.handleFieldSelect}
                     onBlur={this.handleAmountBlur}
                     onChange={this.handleAmountChange}
              />
            </span>
          </div>

            <div className="editor-row">
              <span className="label-column">{_I_("ItemSellEditor.label.wished")} {amountText}</span>
              <span className="input-column text-center">
                <input type="text" className="form-control input-sm" readOnly
                     value={MoneyUtil.formatMoney(totalWished)} />
              </span>
            </div>


            <div className="editor-row">
              <span className="label-column fixup-height-for-button">
                <span  className="agree-checkbox"  onClick={this.onAgreeClick}  >
                  <IconGlyphicon type={this.state.agree ? "check" : "unchecked"} />&nbsp;{_I_("ItemSellEditor.label.agree")}
                </span>&nbsp;
                <a    href={termsUrl}
                      target="_blank"
                      rel="noopener noreferrer"  >
                    {_I_("ItemSellEditor.label.ToU")}&nbsp;<IconGlyphicon type="share" /></a>
              </span>
              <span className="input-column">
                <BootButton variant={disabled ? "primary": "success"} disabled={disabled} block
                            onClick={this.props.processSellOrder}
                            title={submitNotes}
                      ><IconFontAwesome type="check" />&nbsp;{_I_("ItemSellEditor.label.submit")}</BootButton>
              </span>
            </div>

            <div className="notes-row">
            {notes.map(
                (text, key)  =>  <div key={key}><IconGlyphicon type="exclamation-sign" />&nbsp;{text}</div>
              )}
            </div>

        </div>
    );
  }
}


defineSimpleTerm( "ItemSellEditor.label.wheelInput",  "You can use mouse wheel to spin price,\nctrl+wheel = 10x speed,\nshift+wheel=0.1x speed",       {
  "ru_RU": "Можно использовать колесо прокрутки для изменения,\nctrl+колесо = 10x скорость,\nshift+колесо=0.1x скорость",
  "cs_CZ": "You can use mouse wheel to spin price,\nctrl+wheel = 10x speed,\nshift+wheel=0.1x speed",
  "fr_FR": "Vous pouvez utiliser la roulette de votre souris pour faire défiler,\nctrl+roulette = vitesse x10,\nshift+roulette=vitesse x0.1",
  "de_DE": "Du kannst das Mausrad benutzen um den Preis zu ändern,\nstrg+Mausrad = Geschwindigkeit x10,\nshift+Mausrad = Geschwindigkeit x0,1",
  "it_IT": "Puoi utilizzare la rotella del mouse per aumentare il prezzo,\nctrl+rotella = velocità 10x,\nshift+rotella=velocità 0.1x",
  "ko_KR": "마우스 휠키를 이용하여 구매 가격을 결정할 수 있습니다, \nCtrl+휠키로 10단위의 가격을, \nShift+휠키로 0.1단위의 가격을 설정할 수 있습니다.",
  "pl_PL": "Możesz użyć kółka myszy do regulacji ceny,\nctrl+kółko = prędkość 10x\nshift+kółko=prędkość 0.1x",
  "pt_PT": "You can use mouse wheel to spin price,\nctrl+wheel = 10x speed,\nshift+wheel=0.1x speed",
  "es_ES": "Puede usar la rueda del mouse para girar el precio,\nctrl + rueda = 10x speed,\nshift + rueda = 0.1x velocidad",
  "zh_CN": "你可以使用鼠标滚轮转动价格，\nctrl+滚轮 = 10 倍速度，\nshift+滚轮 = 0.1 倍速度",
  "zh_TW": "你可以使用滑鼠滾輪調動價格，\n ctrl+滾輪 = 10 倍速度，\n shift+滾輪 = 0.1 倍速度"
} );


defineSimpleTerm( "ItemSellEditor.note.minPrice",  "The minimum price is",       {
  "ru_RU": "Минимальная цена",
  "cs_CZ": "Minimální cena je",
  "fr_FR": "Le prix minimum est de",
  "de_DE": "Der minimale Preis ist",
  "it_IT": "Il prezzo minimo è",
  "ko_KR": "최소 가격은 다음과 같습니다",
  "pl_PL": "Minimalna cena to",
  "pt_PT": "The minimum price is",
  "es_ES": "El precio minimo es",
  "zh_CN": "最低价格为",
  "zh_TW": "最低價格為"
} );


defineSimpleTerm( "ItemSellEditor.note.maxPrice",  "Maximum sell price alowed",       {
  "ru_RU": "Максимальная цена",
  "cs_CZ": "Maximální povolená prodejní cena",
  "fr_FR": "Prix de vente maximum autorisé",
  "de_DE": "Der maximale Verkaufspreis, der erlaubt ist",
  "it_IT": "Prezzo massimo consentito",
  "ko_KR": "최대 판매 가격은 다음과 같습니다",
  "pl_PL": "Maksymalna dozwolona cena sprzedaży",
  "pt_PT": "Maximum sell price alowed",
  "es_ES": "Precio de venta máximo permitido",
  "zh_CN": "允许的最高售价",
  "zh_TW": "允許的最高售價"
} );


defineSimpleTerm( "ItemSellEditor.note.maxTotals",  "Order totals is over maximum of",       {
  "ru_RU": "Максимальная сумма",
  "cs_CZ": "Order totals is over maximum of",
  "fr_FR": "Le total des commandes est supérieur au maximum de",
  "de_DE": "Die Auftragsanzahl ist über dem Maximum von",
  "it_IT": "Gli ordini totali sono oltre il massimo di",
  "ko_KR": "최대 판매 수량은 다음과 같습니다",
  "pl_PL": "Zamówienie całkowite przekracza maksimum",
  "pt_PT": "Order totals is over maximum of",
  "es_ES": "El total de pedidos supera el máximo de",
  "zh_CN": "订单总数超过最大值",
  "zh_TW": "訂單總數超過最大值"
} );


defineSimpleTerm( "ItemSellEditor.note.maxBalance",  "Total balance should not exceed",       {
  "ru_RU": "Баланс не должен превосходить",
  "cs_CZ": "Total balance should not exceed",
  "fr_FR": "Le montant total sur votre compte ne peut être supérieur à",
  "de_DE": "Der Kontostand darf nicht überschreiten",
  "it_IT": "Il bilancio totale non può eccedere",
  "ko_KR": "가이진 코인의 총량은 다음을 넘길 수 없습니다",
  "pl_PL": "Saldo nie powinno przekraczać",
  "pt_PT": "Total balance should not exceed",
  "es_ES": "El saldo total no debe exceder",
  "zh_CN": "总余额不应超过",
  "zh_TW": "總餘額不應超過"
} );


defineSimpleTerm( "ItemSellEditor.note.mustAgree",  "Must agree to Terms Of Use",       {
  "ru_RU": "Необходимо принять Пользовательское соглашение",
  "cs_CZ": "Must agree to Terms Of Use",
  "fr_FR": "Vous devez accepter les conditions d'utilisation",
  "de_DE": "Du musst den Nutzungsbedingungen zustimmen",
  "it_IT": "Devi accettare i Termini di Utilizzo",
  "ko_KR": "이용 약관에 동의해 주셔야 합니다",
  "pl_PL": "Należy zaakceptować Warunki Korzystania",
  "pt_PT": "Must agree to Terms Of Use",
  "es_ES": "Debe aceptar los Términos de uso",
  "zh_CN": "必须同意使用条款",
  "zh_TW": "必須同意使用條款"
} );


defineSimpleTerm( "ItemSellEditor.label.price",  "Buyer pays (includes fees):",       {
  "ru_RU": "Цена для покупателя (включая комиссию):",
  "cs_CZ": "Buyer pays (includes fees):",
  "fr_FR": "L'acheteur paie (frais inclus):",
  "de_DE": "Käufer zahlt (einschließlich Gebühren):",
  "it_IT": "L'acquirente paga (tasse incluse):",
  "ko_KR": "구매자가 지불할 가격(세금 포함):",
  "pl_PL": "Kupujący płaci (włączając opłaty dodatkowe):",
  "pt_PT": "Buyer pays (includes fees):",
  "es_ES": "El comprador paga (incluye tarifas):",
  "zh_CN": "买方支付（包括费用）：",
  "zh_TW": "買方支付（包括手續費）："
} );


defineSimpleTerm( "ItemSellEditor.label.wished",  "You receive, after fees charged of ",       {
  "ru_RU": "Вы получаете, после отчисления комиссии, за ",
  "cs_CZ": "You receive, after fees charged of ",
  "fr_FR": "You receive, after fees charged of ",
  "de_DE": "You receive, after fees charged of ",
  "it_IT": "You receive, after fees charged of ",
  "ko_KR": "You receive, after fees charged of ",
  "pl_PL": "You receive, after fees charged of ",
  "pt_PT": "You receive, after fees charged of ",
  "es_ES": "You receive, after fees charged of ",
  "zh_CN": "在扣除费用后，你会收到：",
  "zh_TW": "在扣除手續費後，你會收到："
} );


defineSimpleTerm( "ItemSellEditor.label.agree",  "I agree to Gaijin Store",       {
  "ru_RU": "Я соглашаюсь с",
  "cs_CZ": "I agree to Gaijin Store",
  "fr_FR": "J'accepte les conditions d'utilisation de la boutique Gaijin",
  "de_DE": "Ich stimme dem Gaijin-Shop zu",
  "it_IT": "Acconsento al Negozio Gaijin",
  "ko_KR": "가이진 스토어 정책에 동의합니다",
  "pl_PL": "Zgadzam się na Gaijin Store",
  "pt_PT": "I agree to Gaijin Store",
  "es_ES": "Estoy de acuerdo con la Tienda Gaijin",
  "zh_CN": "我同意 Gaijin Store",
  "zh_TW": "我同意 Gaijin Store"
} );


defineSimpleTerm( "ItemSellEditor.label.ToU",  "Terms of Use",       {
  "ru_RU": "Пользовательским соглашением",
  "cs_CZ": "Terms of Use",
  "fr_FR": "Conditions d'utilisation",
  "de_DE": "Nutzungsbedingungen",
  "it_IT": "Termini di Utilizzo",
  "ko_KR": "이용 약관",
  "pl_PL": "Terms of Use",
  "pt_PT": "Terms of Use",
  "es_ES": "Términos de Uso",
  "zh_CN": "使用条款",
  "zh_TW": "使用條款"
} );


defineSimpleTerm( "ItemSellEditor.label.submit",  "OK, put it up for sale",       {
  "ru_RU": "Продать",
  "cs_CZ": "OK, put it up for sale",
  "fr_FR": "OK, mettez le en vente",
  "de_DE": "OK, für den Verkauf bereitstellen",
  "it_IT": "OK, metti in vendita",
  "ko_KR": "네, 판매 목록에 올리겠습니다",
  "pl_PL": "OK, wystaw na sprzedaż",
  "pt_PT": "OK, put it up for sale",
  "es_ES": "OK, ponlo a la venta",
  "zh_CN": "好，把它上架销售",
  "zh_TW": "好，把它上架銷售"
} );


defineSimpleTerm( "ItemSellEditor.currentBalance.before",  "Currently you have",       {
  "ru_RU": "Ваш текущий баланс",
  "cs_CZ": "Currently you have",
  "fr_FR": "Actuellement, vous avez",
  "de_DE": "Im Moment hast du",
  "it_IT": "Attualmente hai",
  "ko_KR": "당신은 현재",
  "pl_PL": "Obecnie posiadasz",
  "pt_PT": "Currently you have",
  "es_ES": "Actualmente tienes",
  "zh_CN": "目前你拥有",
  "zh_TW": "目前你擁有"
} );


defineSimpleTerm( "ItemSellEditor.currentBalance.after",  "on your balance",       {
  "ru_RU": "на вашем балансе",
  "cs_CZ": "on your balance",
  "fr_FR": "sur votre compte",
  "de_DE": "dein Kontostand beträgt",
  "it_IT": "sul tuo bilancio",
  "ko_KR": "의 가이진 코인을 소유하고 있습니다",
  "pl_PL": "na Twoim koncie",
  "pt_PT": "on your balance",
  "es_ES": "en tu saldo",
  "zh_CN": "位于你的余额中",
  "zh_TW": "位於你的餘額中"
} );


defineSimpleTerm( "ItemSellEditor.sellOrdersTotal.before",  "plus",       {
  "ru_RU": "плюс",
  "cs_CZ": "plus",
  "fr_FR": "plus",
  "de_DE": "plus",
  "it_IT": "più",
  "ko_KR": "+",
  "pl_PL": "plus",
  "pt_PT": "plus",
  "es_ES": "mas",
  "zh_CN": "外加",
  "zh_TW": "外加"
} );


defineSimpleTerm( "ItemSellEditor.sellOrdersTotal.after",  "accumulated in sell orders",       {
  "ru_RU": "в ордерах на продажу",
  "cs_CZ": "accumulated in sell orders",
  "fr_FR": "total des ordres de vente",
  "de_DE": "angesammelte Verkaufsaufträge",
  "it_IT": "ordini di vendita accumulati",
  "ko_KR": "누적 판매 주문량",
  "pl_PL": "nagromadzone w poleceniach sprzedaży",
  "pt_PT": "accumulated in sell orders",
  "es_ES": "acumulado en órdenes de venta",
  "zh_CN": "位于出售订单中",
  "zh_TW": "位於出售訂單中"
} );


defineSimpleTerm( "ItemSellEditor.buyOrdersTotal.before",  "and",       {
  "ru_RU": "и",
  "cs_CZ": "and",
  "fr_FR": "et",
  "de_DE": "und",
  "it_IT": "e",
  "ko_KR": "그리고",
  "pl_PL": "i",
  "pt_PT": "and",
  "es_ES": "y",
  "zh_CN": "和",
  "zh_TW": "和"
} );


defineSimpleTerm( "ItemSellEditor.buyOrdersTotal.after",  "accumulated in buy orders",       {
  "ru_RU": "в ордерах на покупку",
  "cs_CZ": "accumulated in buy orders",
  "fr_FR": "total des ordres d'achat",
  "de_DE": "angesammelte Kaufaufträge",
  "it_IT": "ordini d'acquisto accumulati",
  "ko_KR": "누적 구매 주문량",
  "pl_PL": "nagromadzone w poleceniach kupna",
  "pt_PT": "accumulated in buy orders",
  "es_ES": "acumulado en órdenes de compra",
  "zh_CN": "位于购买订单中",
  "zh_TW": "位於購買訂單中"
} );

defineSimpleTerm( "ItemSellEditor.label.amount",  "How many do you want to sell:",       {
  "ru_RU": "Сколько вы хотите продать:",
  "cs_CZ": "Kolik chcete prodat:",
  "fr_FR": "Combien voulez-vous en vendre:",
  "de_DE": "Wie viel möchtest du verkaufen:",
  "it_IT": "How many do you want to sell:",
  "ko_KR": "판매 수량을 결정하십시오:",
  "pl_PL": "Jak dużo chcesz sprzedać:",
  "pt_PT": "Unidades que quer vender:",
  "es_ES": "Cuantos quieres vender:",
  "zh_CN": "您想出售的物品数量：",
  "zh_TW": "您想出售的物品数量："
} );
